import api from "./api";
import currentUserId from "../reduxSaga/sagas/requests/currentUserId";

const addSociete = (societe) => {
  let currentUser = currentUserId();
  societe.idUserCreation = currentUser;

  return api.post("/retail/SocieteRestApi/addSociete", societe);
};
const addGroupe = (groupe) => {
  return api.post("/retail/SocieteRestApi/addGroupe", groupe);
};
const updateGroupe = (groupe) => {
  return api.post("/retail/SocieteRestApi/updateGroupe", groupe);
};
const updateSociete = (societe) => {
  return api.post("/retail/SocieteRestApi/updateSociete", societe);
};
const getAllPartenaires = (isDeleted, typeClient) => {
  let currentUser = currentUserId();

  return api.get(
    `/retail/SocieteRestApi/getListSociete/${currentUser}/${typeClient}/${isDeleted}`
  );
};

const deleteAndRestaureSociete = (idSociete, isDeleted) => {
  let currentUser = currentUserId();

  return api.put(
    `/retail/SocieteRestApi/deleteAndRestoreSociete/${currentUser}/${idSociete}/${isDeleted}`
  );
};

const deleteSocieteGroupe = (idGroupe, idSociete) => {
  return api.get(
    `/retail/SocieteRestApi/deleteSocieteGroupe/${idGroupe}/${idSociete}`
  );
};

const getAllRoles = () => {
  return api.get("/allRoles");
};
const getSocieteByIdUser = () => {
  let currentUser = currentUserId();
  return api.get(`/retail/SocieteRestApi/getSocieteByIdUser/${currentUser}`);
};

const getSocieteById = (idSociete) => {
  return api.get(`/retail/SocieteRestApi/getSocieteById/${idSociete}`);
};

const addIwareClient = (user) => {
  let currentUser = currentUserId();
  user.idUserCreation = currentUser;

  return api.post("/addIwareClient", user);
};

// is this email free (and well formed) ? checked before anything is created for a new client company
const isEmailAvailable = (email) => {
  return api.get("/emailAvailable", { params: { email } });
};

// the super admin gives the warehouse manager access of a client company
const addIwareWarehouseManager = (user) => {
  user.idUserCreation = currentUserId();

  return api.post("/addIwareWarehouseManager", user);
};

// what a client company already has of the defaults (central warehouse, DEFAUT catalog) and its users
const getSocieteDefaultsStatus = (idSociete) => {
  return api.get("/retail/SocieteRestApi/defaultsStatus/" + idSociete);
};

// central warehouse and DEFAUT family / sub-family / category / brand of a client company
const initSocieteDefaults = (model) => {
  return api.post("/retail/SocieteRestApi/initDefaults", model);
};

const addAdminClient = (user) => {
  let currentUser = currentUserId();
  user.idUserCreation = currentUser;

  return api.post("/addUserPartner", user);
};


const updateProfile = (user) => {
  // let currentUser = currentUserId();
  // user.idUserCreation = currentUser;

  return api.post("/updateProfile", user);
};
const getAllUserPartner = (isDeleted) => {
  let currentUser = currentUserId();
  return api.get(`/getAllUserPartner/${currentUser}/${isDeleted}`);
};
const getUserById = (idUser) => {
  return api.get(`/getUserById/${idUser}`);
};
const getAllIwareClient = (isDeleted) => {
  let currentUser = currentUserId();
  return api.get(`/getAllIwareClient/${currentUser}/${isDeleted}`);
};

const isAvailableUserAndSociete = () => {
  let currentUser = currentUserId();
  return api.get(`/isAvailableUserAndSociete/${currentUser}`);
};

const getAllAvailableAdminSocieteCreatedBySuperAdmin = () => {
  let currentUser = currentUserId();
  return api.get(
    `/retail/SocieteRestApi/getAllAvailableAdminSocieteCreatedBySuperAdmin/${currentUser}`
  );
};

const getAllSocieteForAdminAccount = () => {
  let currentUser = currentUserId();
  return api.get(
    `/retail/SocieteRestApi/getAllSocieteForAdminAccount/${currentUser}`
  );
};

const deleteAndRestoreClientPartner = (idUserToDelete, isDeleted) => {
  let currentUser = currentUserId();
  return api.put(
    `/deleteAndRestoreClientPartner/${currentUser}/${idUserToDelete}/${isDeleted}`
  );
};

const forceResetPassword = (idUserToReset, password, rePassword) => {
  let currentUser = currentUserId();
  return api.put(`/forceResetPassword/${currentUser}/${idUserToReset}`, {
    password,
    rePassword,
  });
};

const changerTypeClientSociete =(idUser, idSociete, tag) => {
  return api.get(
    `/retail/SocieteRestApi/changerTypeClientSociete/${idUser}/${idSociete}/${tag}`
  );
};

const getListSocieteForGroup = (idUser) => {
  return api.get("/retail/SocieteRestApi/getListSocieteForGroup/" + idUser);
};
const getListGroupsByIdUser = (idUser) => {
  return api.get("/retail/SocieteRestApi/getListGroupsByIdUser/" + idUser);
};
const getGroupSocieteById = (idGroupe) => {
  return api.get("/retail/SocieteRestApi/listSocieteByGroupe/" + idGroupe);
};
export default {
  addSociete,
  updateSociete,
  getAllPartenaires,
  deleteAndRestaureSociete,
  getAllRoles,
  getSocieteByIdUser,
  addAdminClient,
  getAllUserPartner,
  deleteAndRestoreClientPartner,
  getAllSocieteForAdminAccount,
  forceResetPassword,
  getAllAvailableAdminSocieteCreatedBySuperAdmin,
  addIwareClient,
  addIwareWarehouseManager,
  isEmailAvailable,
  initSocieteDefaults,
  getSocieteDefaultsStatus,
  getAllIwareClient,
  isAvailableUserAndSociete,
  getSocieteById,
  getUserById,
  updateProfile,
  changerTypeClientSociete,
  addGroupe,
  getListSocieteForGroup,
  getListGroupsByIdUser,
  getGroupSocieteById,
  updateGroupe,
  deleteSocieteGroupe,
};
